<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-app>
        <v-navigation-drawer
            app
            v-if="$route.meta.requiresAuth === true"

            dark
            v-model="drawer"
            class="blue lighten-2"
            :expand-on-hover="!fixed"
        >
            <v-list-item class="pa-1">
                <v-list-item-content>
                    <v-list-item-title>{{ botName }}</v-list-item-title>
                    <v-list-item-subtitle v-show="tariff" :title="tariff ? tariff.title : ''" style="cursor: pointer"
                                          @click="dialogTariff = true">Тариф: {{ tariff ? tariff.title : '' }}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-show="botId !== undefined && botId !== null && botId !== ''">
                    <v-btn fab small text @click="editBot" title="Настройки">
                        <v-icon :color="'white'">tune</v-icon>
                    </v-btn>
                </v-list-item-action>
                <v-list-item-action class="ma-0">
                    <v-btn fab small text @click="fixed = !fixed" title="Закрепить">
                        <v-icon :color="fixed ? 'success' : 'default'">{{ fixed ? 'toggle_on' : 'toggle_off' }}</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
            <v-list class="pt-0" dense>
                <router-link v-for="(item, index) in items"
                             :to="item.url.replace('{{botId}}', botId)"
                             style="text-decoration: none; color: inherit;"
                >
                    <v-list-item
                        v-show="item.hasOwnProperty('interfaceIndex') ? getUISettingMain(item.interfaceIndex) : true"

                        :key="index"
                    ><!--@click="goTo(item.url.replace('{{botId}}', botId))"-->
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.hasOwnProperty('interfaceIndex') ? shopDict(item.interfaceIndex) : item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>
            </v-list>
            <tariff-form :dialog="dialogTariff" @close="dialogTariff = false"/>
        </v-navigation-drawer>
        <v-app-bar :short="!mobile" v-if="$route.meta.requiresAuth === true" app><!--Верхнее меню при авторизации-->
            <v-app-bar-nav-icon class="v-size--x-large shrink" @click.stop="drawer = !drawer" app
                                v-if="$route.name !== 'bot-index'"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn class="ma-2" large dark icon v-on="on">
                        <v-avatar
                            color="blue lighten-2"
                            :size="mobile ? 50 : 40"
                        >
                            <img
                                v-if="avatar"
                                :src="avatar"
                                :alt="avatar"
                            >
                            <v-icon v-else>person</v-icon>
                        </v-avatar>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="showUserForm = true">
                        <v-list-item-title>Настройки профиля</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="logOut">
                        <v-list-item-title>Выйти</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <SidebarForGuest></SidebarForGuest>
        <user-form :dialog="showUserForm" @close="showUserForm = false" v-if="$route.meta.requiresAuth === true"/>

        <v-snackbar
            v-model="snackbar"
            bottom
            :color="paramsSnackbar.color"
            right
        >
            {{ paramsSnackbar.text }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <v-content>
            <v-container fluid class="ma-0 pa-0">
                <router-view></router-view>
            </v-container>
        </v-content>
        <BotForm :visible="showScheduleForm" :botId="botId"
                 @close="showScheduleForm = false" @updateBotIndex="changeBotName"/>
    </v-app>
</template>
<script>
import SidebarForGuest from './components/SidebarForGuest'
import axios from 'axios'
import constConf from './constconf'
import {mapGetters} from 'vuex'
import UserForm from './components/user/user/UserForm'
import TariffForm from './components/bot/bot/TariffForm'
import BotForm from './components/bot/bot/BotForm'
import userConstants from './components/user/user/userConstants'
import shopDict from './dicts/shopDict'

export default {
    components: {
        SidebarForGuest,
        UserForm,
        TariffForm,
        BotForm
    },
    data() {
        return {
            botName: 'Бот Бендер',
            botAva: 'https://cdn.icon-icons.com/icons2/1429/PNG/128/icon-robots-16_98547.png',
            botId: null,
            drawer: true,
            clipped: true,
            items: [],
            showUserForm: false,
            snackbar: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            mobile: false,
            cardCategoryFormShowIn: false,
            fixed: true,
            dialogTariff: false,
            showScheduleForm: false
        }
    },
    methods: {
        goTo(url) {
            this.$router.push({path: url})
        },
        updateItems(botId) {
            if (botId === undefined || botId === null || botId === '') {
                this.items = [
                    {title: 'Мои боты', icon: 'dashboard', url: '/bot'}
                ]
            } else {
                this.items = [{title: 'Мои боты', icon: 'closed_caption', url: '/bot'}].concat(userConstants.menuItems)
                if (this.user.user_id === 1) {
                    this.items.push({
                        title: 'Мессенджер',
                        icon: 'message',
                        url: '/bot{{botId}}/im',
                        interfaceIndex: 15
                    })
                }
            }
        },
        logOut() {
            axios.defaults.withCredentials = true
            axios.post(constConf.baseURLApi + '/user/user/logout')
                .then(() => {
                    let d = new Date()
                    d.setDate(d.getDate() - 1)
                    let cookieDate = new Date() // Текущая дата и время
                    cookieDate.setTime(cookieDate.getTime() - 1)
                    document.cookie = 'user=login' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;'
                    // this.$router.push({ path: '/login' })
                    this.$router.go('/login')
                })
                .catch(function (error) {
                    console.error(error.response)
                })
        },
        changeBotName() {
            let botId = this.$route.params['pathMatch']
            this.botName = 'Боты'
            if (botId === undefined || botId === null || botId === '') {
                this.botAva = 'https://cdn.icon-icons.com/icons2/1429/PNG/128/icon-robots-16_98547.png'
                this.botAva = 'https://api.chatway.ru/bot_ava.png'
            } else {
                let bot = this.getBotById(+botId)
                if (bot !== undefined) {
                    this.botName = bot.title
                }
                this.botAva = 'https://api.chatway.ru/bot_ava.png'
                // this.$store.dispatch('cards/cardCategoryAll', +botId)
            }
            this.botId = botId
            this.updateItems(botId)
        },
        cardCategoryShowChange() {
            this.cardCategoryFormShowIn = true
            this.$store.dispatch('cards/cardCategoryShowChange', this.cardCategoryFormShowIn)
        },
        cardCategoryShow(value) {
            if (!value) {
                this.cardCategoryFormShowIn = false
            }
        },
        editBot() {
            this.showScheduleForm = true
        },
        getUISettingMain(bit) {
            let value = this.user.interface_main & (1 << bit)
            return value ? 1 : 0
        },
        shopDict(index) {
            let botId = this.$route.params['pathMatch']
            let bot = this.getBotById(+botId)
            return shopDict.shop.lang.ru.type[(bot ? bot.theme_id : 1)].mainMenuTitles[index]
        },
        connect() {
            if (this.$route['name'] !== 'Login' && this.$route.meta.requiresAuth === true) {
                if (this.$route.query.user_token) {
                    if (this.$route.query.user_token === 'success') {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Подключение к профилю Вконтакте прошло успешно!'
                        this.snackbar = true
                        this.$store.dispatch('user/updateUserVkInfo').then(response => {
                            if (response.data.success) {
                                this.paramsSnackbar.color = 'success'
                                this.paramsSnackbar.text = response.data.success.text
                                this.snackbar = true
                                this.goTo('/bot')
                            } else {
                                this.paramsSnackbar.color = 'error'
                                this.paramsSnackbar.text = response.data.error.text
                                this.snackbar = true
                            }
                        })
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = 'Подключение к профилю Вконтакте прошло с ошибкой!'
                        this.snackbar = true
                    }
                } else if (!this.userLoadedStatus || this.tariffs.length === 0 || this.loadedBots) {
                    this.$store.dispatch('user/loadUser', {data: '', request: 'SideBar created'}).then(response => {
                        if (!response) {
                            let d = new Date()
                            d.setDate(d.getDate() - 1)
                            let cookieDate = new Date() // Текущая дата и время
                            cookieDate.setTime(cookieDate.getTime() - 1)
                            document.cookie = 'user=login' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;'
                            this.$router.push({path: '/login'})
                        }
                    })
                    this.$store.dispatch('bots/tariffAll')
                }
            }
        }
    },
    watch: {
        $route() {
            this.connect()
            this.changeBotName()
        },
        loadedBots() {
            this.changeBotName()
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            userLoadedStatus: 'user/userLoaded',
            getBotById: 'bots/getBotById',
            bots: 'bots/bots',
            tariffs: 'bots/tariffs',
            loadedBots: 'bots/loadedBots',
            cardCategories: 'cards/cardCategories',
            cardCategoryFormShow: 'cards/cardCategoryFormShow',
            getTariffById: 'bots/getTariffById'
        }),
        pageTitle() {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].url.replace('{{botId}}', this.botId) === this.$route.path) {
                    document.title = 'Chatway: ' + this.items[i].title
                    return this.items[i].title
                }
                // if () todo добавить распознавание категории карточек
            }
            document.title = 'Chatway: ' + 'Страничка'
            return 'Страничка'
        },
        avatar() {
            return this.user.avatar ? this.user.avatar : null
        },
        tariff() {
            let botId = this.$route.params['pathMatch']
            let bot = this.getBotById(+botId)
            return bot ? this.getTariffById(bot.tariff_id) : null
        }
    },
    created() {
        document.title = 'Chatway'
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.mobile = true
        }
        this.$store.dispatch('bots/loadBots') // нужно для входа на сайт
        this.botId = this.$route.params['pathMatch']

        this.connect()
        if (this.loadedBots) { // для разработке, при горячей замене кода
            this.changeBotName()
        }
    }
}

</script>

<style lang="scss">

</style>
